import { API_URL } from "../utils/constants";

export const LOCAL_URl = API_URL;
export * from "./profile";
